import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Privacy Policy for Emerging Evidence. Learn how we collect, use, and protect your personal information."
        path="/privacy"
      />
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={styles.lastUpdated}>Last updated: January 27, 2026</p>

          <section style={styles.section}>
            <h2 style={styles.heading}>1. Information We Collect</h2>
            <p style={styles.paragraph}>
              We collect information you provide directly to us, such as when you fill out a contact form, subscribe to our newsletter, or communicate with us. This may include your name, email address, and any other information you choose to provide.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>2. How We Use Your Information</h2>
            <p style={styles.paragraph}>
              We use the information we collect to:
            </p>
            <ul style={styles.list}>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you updates and marketing communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>3. Cookies and Tracking</h2>
            <p style={styles.paragraph}>
              We may use cookies and similar tracking technologies to collect information about your browsing activities. You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>4. Data Security</h2>
            <p style={styles.paragraph}>
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>5. Third-Party Services</h2>
            <p style={styles.paragraph}>
              Our website may contain links to third-party websites or services. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>6. Your Rights</h2>
            <p style={styles.paragraph}>
              You have the right to access, correct, or delete your personal information. To exercise these rights, please <Link to="/contact" style={styles.link}>contact us</Link>.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>7. Changes to This Policy</h2>
            <p style={styles.paragraph}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated revision date.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>8. Contact Us</h2>
            <p style={styles.paragraph}>
              If you have any questions about this Privacy Policy, please <Link to="/contact" style={styles.link}>contact us</Link>.
            </p>
          </section>

          <div style={styles.links}>
            <Link to="/" style={styles.link}>← Back to Home</Link>
            <span style={styles.separator}>|</span>
            <Link to="/terms" style={styles.link}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#000",
    color: "#fff",
    padding: "80px 20px 40px",
    boxSizing: "border-box",
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
  },
  title: {
    fontSize: "2.5rem",
    marginBottom: "0.5rem",
    fontWeight: "300",
  },
  lastUpdated: {
    fontSize: "0.9rem",
    color: "#888",
    marginBottom: "2rem",
  },
  section: {
    marginBottom: "2rem",
  },
  heading: {
    fontSize: "1.3rem",
    fontWeight: "400",
    marginBottom: "0.75rem",
  },
  paragraph: {
    fontSize: "1rem",
    lineHeight: "1.7",
    color: "#ccc",
  },
  list: {
    color: "#ccc",
    lineHeight: "1.8",
    paddingLeft: "1.5rem",
    marginTop: "0.5rem",
  },
  links: {
    marginTop: "3rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #333",
  },
  link: {
    color: "#fff",
    textDecoration: "underline",
    textUnderlineOffset: "4px",
  },
  separator: {
    margin: "0 1rem",
    color: "#666",
  },
};

export default Privacy;
